import { useMutation } from "react-query";
import caseNestUserAlertSettingService from "../../services/caseNestUserAlertSettingService";

const useAddCaseNestUserAlertSetting = () =>
  useMutation(caseNestUserAlertSettingService.create);

export default useAddCaseNestUserAlertSetting;